import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
  } from '@backstage/theme';
  
  export const mandalayTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: palettes.light,
    }),
    defaultPageTheme: 'home',
    components: {
        BackstageTable: {
            styleOverrides:{
                root: {
                    '&> :first-child': {
                      borderBottom: '1px solid #D5D5D5',
                      boxShadow: 'none',
                    },
                    '& th': {
                      borderTop: 'none',
                      textTransform: 'none !important',
                    },
                }
            }
        },
        BackstageMarkdownContent: {           
            styleOverrides: {
                markdown: {
                    'h2': {
                        'font-size': 'medium'
                    }
                }
            }
        }
    },
    pageTheme: {
        home: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
        documentation: genPageTheme({
          colors: ['#8c4351', '#343b58'],
          shape: shapes.wave2,
        }),
        tool: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.round }),
        service: genPageTheme({
          colors: ['#8c4351', '#343b58'],
          shape: shapes.wave,
        }),
        website: genPageTheme({
          colors: ['#8c4351', '#343b58'],
          shape: shapes.wave,
        }),
        library: genPageTheme({
          colors: ['#8c4351', '#343b58'],
          shape: shapes.wave,
        }),
        other: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
        app: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
        apis: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
      },
  });